const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate formEnabledBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const clientInfoSource = {
    type: 'clientInfoBehavior'
  };
  const _await$evaluateSource = await evaluateSource(clientInfoSource, content, parentContentPath, transientContext, nativeFunctions),
    entityName = _await$evaluateSource.entityName,
    formTypeIdentifier = _await$evaluateSource.formTypeIdentifier;
  if (entityName === 'Report') {
    const userPermissionsSource = {
      type: 'getUserPermissionsBehavior'
    };
    const userPermissions = await evaluateSource(userPermissionsSource, content, parentContentPath, transientContext, nativeFunctions);
    const readOnly = userPermissions.includes('report_read_only');
    const isCreatorSource = {
      type: 'isCurrentUserCreatorBehavior'
    };
    const isCreator = await evaluateSource(isCreatorSource, content, parentContentPath, transientContext, nativeFunctions);
    return readOnly && !isCreator ? false : undefined;
  }
  if (entityName === 'Form') {
    const checkPermissionSource = {
      type: 'checkPermissionBehavior',
      action: 'edit',
      formTypeIdentifier
    };
    const hasPermission = await evaluateSource(checkPermissionSource, content, parentContentPath, transientContext, nativeFunctions);
    return hasPermission ? undefined : false;
  }
  return undefined;
};
module.exports = {
  evaluate
};